import React, { FC } from 'react';
import { Col, Flex, Box, Divider } from '@edreamsodigeo/prisma-design-system';
import { usePrime } from 'clientState/providers/PrimeProvider';
import TicketsLeftRibbon from '../TicketsLefRibbon';
import { shallDisplayTicketsLeft } from '../TicketsLefRibbon/TicketsLeftRibbon';
import { LayoutProps } from '../types';
import PriceColumnStandard from '../PriceColumnStandard/PriceColumnStandard';
import { ThreeColumnsItineraryLayoutWrapper } from '@components/Results/Components/ThreeColumnsItinerary/ThreeColumnsItineraryLayout/ThreeColumnsItineraryLayoutWrapper/ThreeColumnsItineraryLayoutWrapper';

const ThreeColumnsItineraryLayoutDefault: FC<LayoutProps> = ({
  itinerary,
  isSem,
  hasRetailingTechniques = true,
  PriceDescription,
  isAlternativeItinerary,
  isAlternativeTopSection,
  hasAlternativeItineraryDecorator,
  isAlternativeItineraryOnModal,
  isSelectedItinerary,
  isUnavailableItinerary,
}) => {
  const { ticketsLeft } = itinerary;
  const { isUK, isPrimeUser, isPrimeSite } = usePrime() || {};
  const withUKStyle =
    isUK && !isPrimeUser && isPrimeSite && !hasAlternativeItineraryDecorator;

  return (
    <ThreeColumnsItineraryLayoutWrapper
      itinerary={itinerary}
      isAlternativeTopSection={isAlternativeTopSection}
      withUKStyle={withUKStyle}
      isAlternativeItineraryOnModal={isAlternativeItineraryOnModal}
      isSelectedItinerary={isSelectedItinerary}
      isAlternativeItinerary={isAlternativeItinerary}
      isUnavailableItinerary={isUnavailableItinerary}
      hasRetailingTechniques={hasRetailingTechniques}
      isSem={isSem}
    >
      <Col>
        <Box height="100%" ml="base" mr="1x_small">
          <Divider orientation="vertical" type="dashed" color="neutral.40" />
        </Box>
      </Col>

      <Flex
        width="72px"
        maxWidth="72px"
        minWidth="72px"
        sx={{
          ...((withUKStyle || isAlternativeTopSection) && {
            py: 'base',
            pr: 'base',
            width: '85px',
            maxWidth: '85px',
            minWidth: '85px',
          }),
        }}
        mt={
          hasRetailingTechniques && shallDisplayTicketsLeft(ticketsLeft)
            ? '1x_big'
            : null
        }
      >
        <PriceColumnStandard
          itinerary={itinerary}
          PriceDescription={PriceDescription}
          hasRetailingTechniques={hasRetailingTechniques}
          isAlternativeItinerary={isAlternativeItinerary}
          isAlternativeItineraryOnModal={isAlternativeItineraryOnModal}
        />
      </Flex>

      {hasRetailingTechniques && (
        <TicketsLeftRibbon
          ticketsNumber={ticketsLeft}
          withUKStyle={withUKStyle}
        />
      )}
    </ThreeColumnsItineraryLayoutWrapper>
  );
};

export default ThreeColumnsItineraryLayoutDefault;
